export default __webpack_public_path__ + "static/media/twitter.75a59549.svg";